<script>
import {
  ref,
  watch
} from "vue";
import "@vueform/multiselect/themes/default.css";

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import useVuelidate from "@vuelidate/core";
import "flatpickr/dist/flatpickr.css";
import Layout from "../../layouts/main.vue";
import appConfig from "../../../app.config";
import PageHeader from "@/components/page-header";
import Papa from 'papaparse';
import axios from "axios";
import Swal from "sweetalert2";
import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import * as XLSX from "xlsx";

import loader from "../../components/widgets/loader";

export default {
  page: {
    title: "Upload Lists",
    meta: [{
      name: "description",
      content: appConfig.description,
    }, ],
  },
  setup() {
    let files = ref([]);
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
      files.value.push(dropzoneFile.value);
    };
    const selectedFile = () => {
      dropzoneFile.value = document.getElementById('listFile').files[0];
      files.value.push(dropzoneFile.value);
    };
    watch(
        () => [...files.value],
        (currentValue) => {
          return currentValue;
        }
    );
    return {
      dropzoneFile,
      drop,
      selectedFile,
      v$: useVuelidate(),
      files
    };
  },
  data() {
    return {
      title: "Upload Client/Lead List",
      items: [{
        text: "Dashboard",
        href: "/",
      },
        {
          text: "Upload List",
          active: true,
        },
      ],
      date1: null,
      datetimeConfig: {
        enableTime: true,
        dateFormat: "d.m.y",
        time_24hr: true,
      },
      editor: ClassicEditor,
      file: [],
      content: [],
      parsed: false,
      statusList: [],
      overWriteFlag: 0,
      typeList: [],
      itemsSearch: [],
      
      // Expected column formats (legacy - kept for backward compatibility)
      spectedColumnsWalking: [
        "Last Name",
        "First Name",
        "Address",
        "City",
        "State",
        "Zip",
        "Daytime Phone",
        "Evening Phone",
        "Age",
        "Media",
        "Language",
        "Received",
        "Assigned",
        "Second Pre-Approach Letter"
      ],
      spectedColumnsNtos: [
        "COPOL",
        "INSURED_NAME",
        "ADDRESS",
        "CITY",
        "ST",
        "ZIP",
        "PHONE",
        "PLAN",
        "ISSUED",
        "PDTO",
        "STS",
        "ANNPRM",
        "ACT",
        "PERSIST",
        "OK"
      ],
      spectedColumnsOrphans: [
        "Dco-Policy #",
        "Owner First Name",
        "Owner Last Name",
        "Policy Phone 1",
        "Policy Address",
        "Policy City",
        "Policy Zip",
        "Plan Description",
        "Monthly Premium",
        "Insured First Name",
        "Insured Last Name",
        "Current Face Amount",
        "AD&D Units",
      ],
      
      listType: 0,
      isLoading: false,
      
      // NEW: Upload Wizard State
      uploadStep: 1, // 1: Upload, 2: Map Columns, 3: Review
      uploadedFile: null,
      parsedHeaders: [],
      parsedData: [],
      columnMapping: {}, // Maps file column → system field
      detectedAgent: null,
      fileType: '', // 'csv', 'pdf', 'excel'
      
      // System fields for mapping
      systemFields: [
        { key: 'policyNumber', label: 'Policy Number (COPOL)', required: false },
        { key: 'fullName', label: 'Full Name (will split to First/Last) *', required: true, isSplittable: true },
        { key: 'firstName', label: 'First Name *', required: true },
        { key: 'lastName', label: 'Last Name *', required: true },
        { key: 'address', label: 'Address', required: false },
        { key: 'city', label: 'City', required: false },
        { key: 'state', label: 'State', required: false },
        { key: 'stateZip', label: 'State & ZIP (will split)', required: false, isSplittable: true },
        { key: 'zip', label: 'ZIP Code', required: false },
        { key: 'phone', label: 'Phone *', required: true },
        { key: 'planType', label: 'Plan Type', required: false },
        { key: 'issueDate', label: 'Issue Date', required: false },
        { key: 'pdto', label: 'PDTO', required: false },
        { key: 'annualPremium', label: 'Annual Premium', required: false },
        { key: 'accountType', label: 'Account Type', required: false },
        { key: 'policyStatus', label: 'Policy Status', required: false },
        { key: 'age', label: 'Age', required: false },
        { key: 'media', label: 'Media', required: false },
        { key: 'language', label: 'Language (from file)', required: false },
        { key: 'note', label: 'Comment / Note', required: false },
      ],
      
      validationErrors: [],
      
      // Progress tracking
      uploadProgress: {
        isUploading: false,
        currentChunk: 0,
        totalChunks: 0,
        percentage: 0,
        successfulRows: 0,
        failedRows: 0,
        errors: []
      }
    };
  },
  components: {
    Layout,
    PageHeader,
    SimpleTypeahead,
    loader
  },
  methods: {
    deleteRecord(ele) {
      ele.target.parentElement.parentElement.remove();
    },
    
    /**
     * Handle file selection - Step 1
     */
    async handleFileUpload() {
      this.uploadedFile = document.getElementById('listFile').files[0];
      
      if (!this.uploadedFile) {
        return;
      }
      
      this.isLoading = true;
      
      try {
        // Detect file type
        const fileName = this.uploadedFile.name.toLowerCase();
        if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
          this.fileType = 'excel';
          await this.parseExcelFile();
        } else if (fileName.endsWith('.csv')) {
          this.fileType = 'csv';
          await this.parseCSVFile();
        } else {
          await Swal.fire({
            title: "Unsupported file format!",
            text: "Please upload an Excel file (.xlsx, .xls) or CSV file (.csv).",
            icon: 'warning',
            confirmButtonClass: "btn btn-info",
            buttonsStyling: false,
            showCloseButton: true,
          });
          this.isLoading = false;
          return;
        }
        
        // If parsing successful, move to step 2
        if (this.parsedHeaders.length > 0 && this.parsedData.length > 0) {
          this.uploadStep = 2;
          this.autoMapColumns();
        }
        
      } catch (error) {
        console.error('File parsing error:', error);
        await Swal.fire({
          title: "Failed to parse file!",
          text: error.message || "An error occurred while reading the file.",
          icon: 'error',
          confirmButtonClass: "btn btn-danger",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
      
      this.isLoading = false;
    },
    
    /**
     * Parse CSV file (existing logic - kept for backward compatibility)
     */
    async parseCSVFile() {
      return new Promise((resolve, reject) => {
        Papa.parse(this.uploadedFile, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            this.parsedHeaders = results.meta.fields;
            this.parsedData = results.data;
            
            // Detect list type
            if (this.compare(this.spectedColumnsWalking, results.meta.fields)) {
              this.listType = 1;
            } else if (this.compare(this.spectedColumnsNtos, results.meta.fields)) {
              this.listType = 2;
            } else if (this.compare(this.spectedColumnsOrphans, results.meta.fields)) {
              this.listType = 3;
            } else {
              // Unknown format - let user map columns
              this.listType = 0;
            }
            
            resolve();
          },
          error: (error) => {
            reject(error);
          }
        });
      });
    },
    
    /**
     * Parse Excel file
     */
    async parseExcelFile() {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            
            // First row is headers - ensure all are strings
            this.parsedHeaders = jsonData[0].map(h => String(h || '').trim()).filter(h => h);
            
            // Remaining rows are data - convert all values to strings
            this.parsedData = jsonData.slice(1).map(row => {
              const obj = {};
              this.parsedHeaders.forEach((header, index) => {
                // Convert to string to prevent 'float' object has no attribute 'strip' error
                const value = row[index];
                obj[header] = value !== undefined && value !== null ? String(value).trim() : '';
              });
              return obj;
            });
            
            this.listType = 0; // Unknown format
            resolve();
          } catch (error) {
            reject(error);
          }
        };
        
        reader.onerror = (error) => {
          reject(error);
        };
        
        reader.readAsArrayBuffer(this.uploadedFile);
      });
    },
    
    /**
     * Auto-map columns from file to system fields
     */
    autoMapColumns() {
      // Auto-mapping for Excel files
      const mapping = {};
      
      this.parsedHeaders.forEach(header => {
        // Ensure header is a string before calling toLowerCase()
        if (!header || typeof header !== 'string') return;
        const lowerHeader = header.toLowerCase().trim();
        
        // Match common patterns
        if (lowerHeader.includes('policy') || lowerHeader === 'copol') {
          mapping[header] = 'policyNumber';
        } else if (lowerHeader.includes('first') && lowerHeader.includes('name')) {
          mapping[header] = 'firstName';
        } else if (lowerHeader.includes('last') && lowerHeader.includes('name')) {
          mapping[header] = 'lastName';
        } else if (lowerHeader === 'insured_name' || (lowerHeader.includes('name') && !lowerHeader.includes('first') && !lowerHeader.includes('last'))) {
          mapping[header] = 'fullName';
        } else if (lowerHeader.includes('address')) {
          mapping[header] = 'address';
        } else if (lowerHeader.includes('city')) {
          mapping[header] = 'city';
        } else if (lowerHeader.includes('state') && !lowerHeader.includes('zip')) {
          mapping[header] = 'state';
        } else if ((lowerHeader.includes('st') && lowerHeader.includes('zip')) || lowerHeader === 'st zip') {
          mapping[header] = 'stateZip';
        } else if (lowerHeader.includes('zip') && !lowerHeader.includes('state')) {
          mapping[header] = 'zip';
        } else if (lowerHeader.includes('phone')) {
          mapping[header] = 'phone';
        } else if (lowerHeader.includes('plan')) {
          mapping[header] = 'planType';
        } else if (lowerHeader.includes('premium') || lowerHeader === 'ann prm' || lowerHeader === 'annprm') {
          mapping[header] = 'annualPremium';
        } else if (lowerHeader === 'age' || lowerHeader === 'edad') {
          mapping[header] = 'age';
        } else if (lowerHeader.includes('language') || lowerHeader === 'idioma') {
          mapping[header] = 'language';
        }
      });
      
      this.columnMapping = mapping;
    },
    
    /**
     * Get mapped field for a column
     */
    getMappedFieldForColumn(column) {
      return this.columnMapping[column] || '';
    },
    
    /**
     * Update column mapping
     */
    updateColumnMapping(column, fieldKey) {
      if (fieldKey) {
        this.columnMapping[column] = fieldKey;
      } else {
        delete this.columnMapping[column];
      }
    },
    
    /**
     * Get transformed field keys from mapping
     */
    getTransformedFieldKeys() {
      return Object.values(this.columnMapping).filter(val => val);
    },
    
    /**
     * Get field label from key
     */
    getFieldLabel(fieldKey) {
      const field = this.systemFields.find(f => f.key === fieldKey);
      return field ? field.label : fieldKey;
    },
    
    /**
     * Get mapped preview data (first 5 rows)
     */
    getMappedPreviewData() {
      const preview = this.parsedData.slice(0, 5);
      return preview.map(row => {
        const mappedRow = {};
        Object.entries(this.columnMapping).forEach(([fileColumn, crmField]) => {
          mappedRow[crmField] = row[fileColumn] || '';
        });
        return mappedRow;
      });
    },
    
    /**
     * Navigate to next step
     */
    async nextStep() {
      if (this.uploadStep === 1) {
        // Process file
        await this.handleFileUpload();
      } else if (this.uploadStep === 2) {
        // Validate mapping
        if (this.validateColumnMapping()) {
          this.uploadStep = 3;
        }
      }
    },
    
    /**
     * Navigate to previous step
     */
    previousStep() {
      if (this.uploadStep > 1) {
        this.uploadStep--;
      }
    },
    
    /**
     * Validate column mapping
     */
    validateColumnMapping() {
      this.validationErrors = [];
      
      // Check that required fields are mapped
      const mappedFields = Object.values(this.columnMapping);
      
      // Check if fullName is mapped (can substitute for firstName + lastName)
      const hasFullName = mappedFields.includes('fullName');
      const hasFirstAndLast = mappedFields.includes('firstName') && mappedFields.includes('lastName');
      
      if (!hasFullName && !hasFirstAndLast) {
        this.validationErrors.push('You must map either "Full Name" or both "First Name" and "Last Name"');
      }
      
      if (!mappedFields.includes('phone')) {
        this.validationErrors.push('Phone field is required');
      }
      
      if (this.validationErrors.length > 0) {
        let errorList = this.validationErrors.map(err => `• ${err}`).join('<br>');
        Swal.fire({
          title: "Column Mapping Incomplete",
          html: errorList,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
        return false;
      }
      
      return true;
    },
    
    /**
     * Transform mapped data for upload
     */
    transformDataForUpload() {
      return this.parsedData.map(row => {
        const transformedRow = {};
        
        Object.entries(this.columnMapping).forEach(([fileColumn, crmField]) => {
          let value = row[fileColumn] || '';
          
          // Handle special transformations
          if (crmField === 'note' && value) {
            if (!transformedRow['notes_data']) transformedRow['notes_data'] = {};
            transformedRow['notes_data'][fileColumn] = value;
          } else if (crmField === 'fullName' && value) {
            // Split full name
            const parts = value.trim().split(/\s+/);
            transformedRow['firstName'] = parts[0] || '';
            transformedRow['lastName'] = parts.slice(1).join(' ') || '';
          } else if (crmField === 'stateZip' && value) {
            // Split "TX 78521" into state and zip
            const match = value.match(/([A-Z]{2})\s*(\d{5})/);
            if (match) {
              transformedRow['state'] = match[1];
              transformedRow['zip'] = match[2];
            }
          } else {
            transformedRow[crmField] = value;
          }
        });
        
        // Ensure firstName and lastName are present - use "NO NAME" as fallback
        if (!transformedRow['firstName'] || transformedRow['firstName'].trim() === '') {
          transformedRow['firstName'] = 'NO NAME';
        }
        if (!transformedRow['lastName'] || transformedRow['lastName'].trim() === '') {
          transformedRow['lastName'] = 'NO NAME';
        }
        
        return transformedRow;
      });
    },
    
    /**
     * Process and upload with chunking
     */
    async processAndUpload() {
      this.validationErrors = [];
      
      // Validate form fields
      if (document.getElementById('isProspect').value === '') {
        this.validationErrors.push('Please select if this is Prospect or Client');
      }
      
      if (document.getElementById('editLanguage').value === '') {
        this.validationErrors.push('Language is required');
      }
      
      if (document.getElementById('editStatus').value === '') {
        this.validationErrors.push('Status is required');
      }
      
      if (document.getElementById('editType').value === '') {
        this.validationErrors.push('Source is required');
      }
      
      if (document.getElementById('typeahead_id').value === '') {
        this.validationErrors.push('Agent assignment is required');
      }
      
      if (this.validationErrors.length > 0) {
        let errorList = this.validationErrors.map(err => `<b>${err}</b>`).join('<br>');
        await Swal.fire({
          html: "Please complete the form!<br><br>" + errorList,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
        return;
      }
      
      // Transform data
      const transformedData = this.transformDataForUpload();
      
      // Calculate chunks
      const CHUNK_SIZE = 500;
      const totalChunks = Math.ceil(transformedData.length / CHUNK_SIZE);
      
      // Initialize progress
      this.uploadProgress = {
        isUploading: true,
        currentChunk: 0,
        totalChunks: totalChunks,
        percentage: 0,
        successfulRows: 0,
        updatedRows: 0,
        failedRows: 0,
        errors: []
      };
      
      // Upload session ID
      const uploadId = this.generateUploadId();
      
      // Upload chunks
      for (let i = 0; i < totalChunks; i++) {
        const start = i * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, transformedData.length);
        const chunkData = transformedData.slice(start, end);
        
        try {
          const chunkResponse = await this.uploadChunk(i, totalChunks, chunkData, uploadId);
          
          this.uploadProgress.currentChunk = i + 1;
          this.uploadProgress.percentage = Math.round(((i + 1) / totalChunks) * 100);
          
          if (chunkResponse && chunkResponse.inserted !== undefined) {
             this.uploadProgress.successfulRows += chunkResponse.inserted;
             this.uploadProgress.updatedRows += (chunkResponse.updated || 0);
             if (chunkResponse.errors && chunkResponse.errors.length > 0) {
               this.uploadProgress.failedRows += chunkResponse.errors.length;
             }
          } else {
             // Fallback if backend doesn't return structured data
             this.uploadProgress.successfulRows += chunkData.length;
          }
          
        } catch (error) {
          console.error(`Chunk ${i + 1} failed:`, error);
          this.uploadProgress.failedRows += chunkData.length;
          this.uploadProgress.errors.push(`Chunk ${i + 1}: ${error.message}`);
        }
      }
      
      // Upload complete
      this.uploadProgress.isUploading = false;
      
      // Notify the agent
      try {
        await axios.post('/api/client/notifyAgentUploadComplete', {
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id'),
          userEmail: localStorage.getItem('email'),
          uploadTo: document.getElementById('typeahead_id').value,
          isProspect: document.getElementById('isProspect').value,
          source: document.getElementById('editType').value,
          successfulRows: this.uploadProgress.successfulRows,
          updatedRows: this.uploadProgress.updatedRows,
          failedRows: this.uploadProgress.failedRows
        });
      } catch (err) {
        console.error("Failed to send notification sms:", err);
      }
      
      if (this.uploadProgress.failedRows === 0) {
        let successHtml = `Successfully imported <b>${this.uploadProgress.successfulRows}</b> records.`;
        if (this.uploadProgress.updatedRows > 0) {
          successHtml += `<br>Updated/Duplicated <b>${this.uploadProgress.updatedRows}</b> records.`;
        }
        await Swal.fire({
          icon: 'success',
          title: 'Upload Complete!',
          html: successHtml,
        });
        
        // Reset and reload
        setTimeout(() => {
          location.reload();
        }, 2000);
      } else {
        await Swal.fire({
          icon: 'warning',
          title: 'Upload Completed with Errors',
          html: `
            <p>Successful: <b>${this.uploadProgress.successfulRows}</b></p>
            <p>Updated/Duplicated: <b>${this.uploadProgress.updatedRows}</b></p>
            <p>Failed: <b>${this.uploadProgress.failedRows}</b></p>
          `,
        });
      }
    },
    
    /**
     * Upload a single chunk
     */
    async uploadChunk(chunkIndex, totalChunks, chunkData, uploadId) {
      const data = {
        token: localStorage.getItem('jwt'),
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        chunkIndex: chunkIndex,
        totalChunks: totalChunks,
        chunkData: chunkData,
        uploadId: uploadId,
        metadata: {
          uploadTo: document.getElementById('typeahead_id').value,
          isProspect: document.getElementById('isProspect').value,
          language: document.getElementById('editLanguage').value,
          status: document.getElementById('editStatus').value,
          source: document.getElementById('editType').value,
          listType: this.listType,
          detectedAgent: this.detectedAgent
        }
      };
      
      const response = await axios.post('/api/client/uploadListChunked', data);
      
      if (response.status !== 200) {
        throw new Error('Chunk upload failed');
      }
      
      return response.data;
    },
    
    /**
     * Generate unique upload ID
     */
    generateUploadId() {
      return 'upload_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    },
    
    /**
     * Reset upload wizard
     */
    resetUploadWizard() {
      this.uploadStep = 1;
      this.uploadedFile = null;
      this.parsedHeaders = [];
      this.parsedData = [];
      this.columnMapping = {};
      this.detectedAgent = null;
      this.fileType = '';
      this.files = [];
      this.validationErrors = [];
    },
    
    // Legacy methods (kept for backward compatibility)
    parseFile() {
      Papa.parse(this.file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          if (this.compare(this.spectedColumnsWalking, results.meta.fields)) {
            this.content = results;
            this.parsed = true;
            this.listType = 1;
          } else if (this.compare(this.spectedColumnsNtos, results.meta.fields)) {
            this.content = results;
            this.parsed = true;
            this.listType = 2;
          } else if (this.compare(this.spectedColumnsOrphans, results.meta.fields)) {
            this.content = results;
            this.parsed = true;
            this.listType = 3;
          } else {
            Swal.fire({
              title: "Oops, this file is not what we expected!",
              icon: 'warning',
              confirmButtonClass: "btn btn-info",
              buttonsStyling: false,
              showCloseButton: true,
            });
          }
        }.bind(this)
      });
    },
    
    compare(o1, o2) {
      for (let p in o1) {
        if (Object.prototype.hasOwnProperty.call(o1, p)) {
          if (o1[p] !== o2[p]) {
            return false;
          }
        }
      }
      for (let p in o2) {
        if (Object.prototype.hasOwnProperty.call(o2, p)) {
          if (o1[p] !== o2[p]) {
            return false;
          }
        }
      }
      return true;
    },
    
    async changeType() {
      const data = {
        token: localStorage.getItem('jwt'),
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        isProspect: document.getElementById('isProspect').value,
        deleted: 0,
      }

      await axios
          .post('/api/client/clientStatus', data)
          .then(response => {
            this.statusList = response.data
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
            }
          })

      await axios
          .post('/api/client/clientTypes', data)
          .then(response => {
            this.typeList = response.data
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Types could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },
    
    async searchAgents() {
      const data = {
        token: localStorage.getItem('jwt'),
        searchValue: document.getElementById('typeahead_id').value
      }

      if (data['searchValue'].length > 3) {
        await axios
            .post('/api/userFinder', data)
            .then(async response => {
              this.itemsSearch = response.data;
            })
            .catch(async error => {
              if (error.response) {
                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      }
    },
  },
  
  async mounted() {
    const data = {
      token: localStorage.getItem('jwt'),
      userEmail: localStorage.getItem('email'),
      userID: localStorage.getItem('id'),
      isProspect: 1,
      deleted: 0,
    }

    await axios
        .post('/api/client/clientStatus', data)
        .then(response => {
          this.statusList = response.data
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    await axios
        .post('/api/client/clientTypes', data)
        .then(response => {
          this.typeList = response.data
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }
            Swal.fire("Oops!", "Types could not be loaded, please contact your SysAdmin.", "error")
          }
        })
  }
};
</script>

<style>
.simple-typeahead-list-item {
  color: black;
}

.step-indicator {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.step-item {
  display: flex;
  align-items: center;
  flex: 1;
}

.step-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 0.75rem;
}

.step-active .step-number {
  background-color: var(--vz-primary);
  color: white;
}

.step-inactive .step-number {
  background-color: #e9ecef;
  color: #6c757d;
}

.step-connector {
  flex: 1;
  height: 2px;
  background-color: #e9ecef;
  margin: 0 1rem;
}

.upload-progress-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.progress-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <loader v-if="isLoading" :isLoading="isLoading" />
    
    <!-- Progress Modal -->
    <div v-if="uploadProgress.isUploading" class="upload-progress-modal">
      <div class="progress-content">
        <h4 class="mb-3">📤 Importing Data...</h4>
        
        <div class="progress mb-3" style="height: 30px;">
          <div class="progress-bar progress-bar-striped progress-bar-animated" 
               role="progressbar" 
               :style="{width: uploadProgress.percentage + '%'}"
               :aria-valuenow="uploadProgress.percentage" 
               aria-valuemin="0" 
               aria-valuemax="100">
            {{ uploadProgress.percentage }}%
          </div>
        </div>
        
        <p class="mb-2">
          Processing chunk {{ uploadProgress.currentChunk }} of {{ uploadProgress.totalChunks }}...
        </p>
        
        <div class="alert alert-info mb-0">
          <p class="mb-1">✅ <strong>Imported:</strong> {{ uploadProgress.successfulRows }} records</p>
          <p class="mb-0" v-if="uploadProgress.failedRows > 0">
            ❌ <strong>Failed:</strong> {{ uploadProgress.failedRows}} records
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            
            <!-- Step Indicator -->
            <div class="step-indicator mb-4">
              <div class="step-item" :class="uploadStep >= 1 ? 'step-active' : 'step-inactive'">
                <div class="step-number">1</div>
                <span>Upload File</span>
              </div>
              <div class="step-connector"></div>
              <div class="step-item" :class="uploadStep >= 2 ? 'step-active' : 'step-inactive'">
                <div class="step-number">2</div>
                <span>Map Columns</span>
              </div>
              <div class="step-connector"></div>
              <div class="step-item" :class="uploadStep >= 3 ? 'step-active' : 'step-inactive'">
                <div class="step-number">3</div>
                <span>Review & Import</span>
              </div>
            </div>
            
            <!-- STEP 1: Upload File -->
            <div v-if="uploadStep === 1">
              <h5 class="mb-3">📂 Step 1: Upload Your Excel File</h5>
              
              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Upload Instructions</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>We accept <strong>CSV, Excel (.xlsx, .xls)</strong> files</li>
                  <li>Your file <strong>must have column headers</strong> in the first row</li>
                  <li>In the next step, you'll <strong>map each column</strong> from your file to our system fields</li>
                  <li><strong>Important:</strong> Only mapped columns will be imported - unmapped data will be skipped</li>
                  <li><em>Optional:</em> Download a template below to see the recommended format</li>
                </ul>
              </div>
              
              <div class="vstack gap-2">
                <h6>
                  <a href="https://dmbgroup.online/wp-content/uploads/2024/08/Plantilla-para-subir-agentes.csv" 
                     download="Plantilla-para-subir-agentes.csv">
                    <span style="color:darkgreen; font-size: 0.9em;">📥 Download Agents .csv Template</span>
                  </a>
                </h6>
                <h6>
                  <a href="https://dmbgroup.online/wp-content/uploads/2024/08/plantilla-para-clientes-o-prospectos-DMB-INSURANCE-CRM.csv" 
                     download="plantilla-para-clientes-o-prospectos-DMB-INSURANCE-CRM.csv">
                    <span style="color:darkgreen; font-size: 0.9em;">📥 Download Clients/Prospects .csv Template</span>
                  </a>
                </h6>
                
                <label for="listFile" class="fs-14 mb-1">Upload Your List</label>
                <input class="form-control form-control-lg" id="listFile" type="file"
                       accept=".xlsx,.xls" @change="selectedFile"/>
                
                <!-- File Info -->
                <div v-if="uploadedFile" class="alert alert-success mt-3">
                  <i class="ri-file-check-line me-2"></i>
                  <strong>{{ uploadedFile.name }}</strong> 
                  ({{ (uploadedFile.size / 1024).toFixed(2) }} KB)
                </div>
                
                <div v-for="(file, index) of files" :key="index" class="border rounded">
                  <div class="d-flex align-items-center p-2">
                    <div class="flex-grow-1">
                      <div class="pt-1">
                        <h5 class="fs-14 mb-1">{{ file.name }}</h5>
                        <p class="fs-13 text-muted mb-0">
                          <strong>{{ (file.size / 1024).toFixed(2) }}</strong> KB
                        </p>
                      </div>
                    </div>
                    <div class="flex-shrink-0 ms-3">
                      <button class="btn btn-sm btn-danger" @click="deleteRecord">Delete</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- STEP 2: Map Columns -->
            <div v-if="uploadStep === 2">
              <h5 class="mb-3">🗺️ Step 2: Map Your Columns</h5>

              <!-- Mobile Rotate Notice -->
              <div class="alert alert-danger d-block d-md-none mb-3">
                <i class="ri-smartphone-line me-1"></i> <strong>Tip:</strong> For a better experience, rotate your phone horizontally to see all columns clearly.
              </div>
              
              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Mapping Instructions</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>We've automatically detected and mapped some columns for you - <strong>please verify they are correct</strong></li>
                  <li><strong>You must select a field</strong> for each column you want to import using the dropdowns below</li>
                  <li>Fields marked with <strong>*</strong> are required (First Name or Full Name, Last Name, and Phone)</li>
                  <li>Columns set to "-- Skip this column --" will <strong>not be imported</strong></li>
                  <li>The "Sample Data" column shows the first row to help you verify the mapping</li>
                </ul>
              </div>
              
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th class="text-nowrap">Your Column</th>
                      <th class="text-nowrap">Sample Data</th>
                      <th style="min-width: 200px;">Map To Field</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(header, index) in parsedHeaders" :key="index">
                      <td class="text-nowrap"><strong>{{ header }}</strong></td>
                      <td class="text-muted text-nowrap" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis;">{{ parsedData[0] ? parsedData[0][header] : '' }}</td>
                      <td>
                        <select class="form-select" 
                                :value="getMappedFieldForColumn(header)"
                                @change="updateColumnMapping(header, $event.target.value)">
                          <option value="">-- Skip this column --</option>
                          <option v-for="field in systemFields" :key="field.key" :value="field.key">
                            {{ field.label }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            <!-- STEP 3: Review & Import -->
            <div v-if="uploadStep === 3">
              <h5 class="mb-3">✅ Step 3: Review & Import</h5>
              
              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Final Steps</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>Review the preview below to ensure data is mapped correctly</li>
                  <li>Fill in all required fields (Agent, Status, Language, Source)</li>
                  <li>Click "Process & Upload" to begin importing your data</li>
                  <li>Large files will be processed in chunks - please wait for completion</li>
                </ul>
              </div>
              
              <!-- Import Settings -->
              <div class="row mb-4">
                <div class="col-lg-6">
                  <label for="isProspect" class="form-label">Is Prospect *</label>
                  <select class="form-select mb-2" id="isProspect" @change="changeType">
                    <option value="">...</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
                <div class="col-lg-6">
                  <label for="editLanguage" class="form-label">Language *</label>
                  <select class="form-select mb-2" id="editLanguage">
                    <option value="">...</option>
                    <option value="1">English</option>
                    <option value="2">Spanish</option>
                    <option value="3">Take from List</option>
                  </select>
                </div>
              </div>
              
              <div class="row mb-4">
                <div class="col-lg-6">
                  <label for="editStatus" class="form-label">Status *</label>
                  <select class="form-select mb-2" id="editStatus">
                    <option value="">...</option>
                    <option v-for="(status, statusIndex) of statusList" 
                            :key="statusIndex" 
                            :value="status.statusID">
                      {{ status.name }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-6">
                  <label for="editType" class="form-label">Source *</label>
                  <select class="form-select mb-2" id="editType">
                    <option value="">...</option>
                    <option v-for="(type, typeIndex) of typeList" 
                            :key="typeIndex" 
                            :value="type.name">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
              </div>
              
              <div class="row mb-4">
                <div class="col-md-6">
                  <label for="typeahead_id" class="form-label">Assigned To *</label>
                  <SimpleTypeahead
                      id="typeahead_id"
                      placeholder="Type agent name to search..."
                      :items="itemsSearch"
                      :minInputLength="3"
                      :class="'form-control mb-2'"
                      @onInput="searchAgents">
                  </SimpleTypeahead>
                  <small v-if="detectedAgent" class="text-muted">
                    Agent detected from file: <strong>{{ detectedAgent }}</strong>
                  </small>
                </div>
                <div class="col-md-6">
                  <label for="overwriteID" class="form-label">Overwrite Existing Data</label>
                  <select class="form-select mb-2" id="overwriteID">
                    <option value="0">No</option>
                    <option value="1">Yes</option>
                  </select>
                </div>
              </div>
              
              <!-- Data Preview -->
              <h6>Data Preview (first 5 rows)</h6>
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr>
                      <th>#</th>
                      <th v-for="(fieldKey, index) in getTransformedFieldKeys()" :key="index">
                        {{ getFieldLabel(fieldKey) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, rowIndex) in getMappedPreviewData()" :key="rowIndex">
                      <td>{{ rowIndex + 1 }}</td>
                      <td v-for="(fieldKey, index) in getTransformedFieldKeys()" :key="index">
                        {{ row[fieldKey] }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              
              <div class="alert alert-info mt-3">
                <i class="ri-information-line me-2"></i>
                Ready to import <strong>{{ parsedData.length }}</strong> records
              </div>
            </div>
            
            <!-- Navigation Buttons -->
            <div class="d-flex justify-content-between mt-4">
              <button type="button" class="btn btn-light" @click="previousStep" v-if="uploadStep > 1">
                <i class="ri-arrow-left-line me-1"></i> Previous
              </button>
              <div v-else></div>
              
              <button type="button" class="btn btn-primary" @click="nextStep" v-if="uploadStep < 3">
                Next <i class="ri-arrow-right-line ms-1"></i>
              </button>
              <button type="button" class="btn btn-success" @click="processAndUpload" v-if="uploadStep === 3">
                <i class="ri-upload-cloud-line me-1"></i> Import Data
              </button>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>